import { createContext } from 'react';

import { type XYChartLegend } from '../types/xy-chart.js';

export const XYChartTruncationModeContext = createContext<
  XYChartLegend | undefined
>(undefined);

XYChartTruncationModeContext['displayName'] = 'XYChartTruncationModeContext';
